import { render, staticRenderFns } from "./KDialog.vue?vue&type=template&id=144aed61&scoped=true&lang=pug&"
import script from "./KDialog.vue?vue&type=script&lang=ts&"
export * from "./KDialog.vue?vue&type=script&lang=ts&"
import style0 from "./KDialog.vue?vue&type=style&index=0&id=144aed61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144aed61",
  null
  
)

export default component.exports